module.exports = __webpack_public_path__ + "2fd20d376c5b87b792ec48fa40165237.pdf";